import { Radio, SelectionStatus } from '@symphony-ui/uitoolkit-components';
import GenericBenchmark from '../../../../../../models/data/GenericBenchmark';
import * as React from 'react';
import SwapBenchmarkEditor from './SwapBenchmarkEditor';
import GovernmentBondBenchmarkEditor from './GovernmentBondBenchmarkEditor';
import ReferenceRateEditor from '../coupons/ReferenceRateEditor';
import FutureBenchmarkEditor from './FutureBenchmarkEditor.';
import FutureBenchmark from '../../../../../../models/data/FutureBenchmark';
const GenericBenchmarkEditor = ({ onChange, value }) => {
    const [type, setType] = React.useState('swap');
    const onChangeType = React.useCallback((event) => {
        const target = event.target;
        setType(target.name);
    }, []);
    const onChangeInterestRate = React.useCallback((event) => {
        const newValue = new GenericBenchmark({ interestRate: event.target.value });
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const onChangeGovernmentBond = React.useCallback((event) => {
        const newValue = new GenericBenchmark({ governmentBond: event.target.value });
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const onChangeSwap = React.useCallback((event) => {
        const newValue = new GenericBenchmark({ swap: event.target.value });
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const onChangeFuture = React.useCallback((event) => {
        const newValue = new GenericBenchmark({ future: event.target.value });
        onChange({ target: { value: newValue } });
    }, [onChange]);
    const content = React.useMemo(() => {
        switch (type) {
            case 'swap':
                return React.createElement(SwapBenchmarkEditor, { value: value?.swap, onChange: onChangeSwap });
            case 'gov':
                return React.createElement(GovernmentBondBenchmarkEditor, { value: value?.governmentBond, onChange: onChangeGovernmentBond });
            case 'stir':
                return React.createElement(ReferenceRateEditor, { disabled: false, value: value?.interestRate, onChange: onChangeInterestRate });
            case 'fut':
                onChange({ target: { value: new GenericBenchmark({ future: new FutureBenchmark({ type: 'EFP' }) }) } });
                return React.createElement(FutureBenchmarkEditor, { value: value?.future ?? new FutureBenchmark({ type: 'EFP' }), onChange: onChangeFuture });
        }
    }, [onChangeGovernmentBond, onChangeInterestRate, onChangeSwap, value?.governmentBond, value?.interestRate, value?.swap, type]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement(Radio, { label: "Swap", name: 'swap', onChange: onChangeType, status: type === 'swap' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: type }),
            React.createElement(Radio, { label: "Gov. Bond", name: 'gov', onChange: onChangeType, status: type === 'gov' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: type }),
            React.createElement(Radio, { label: "STIR", name: 'stir', onChange: onChangeType, status: type === 'stir' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: type }),
            React.createElement(Radio, { label: "Fut.", name: 'fut', onChange: onChangeType, status: type === 'fut' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: type })),
        content));
};
export default GenericBenchmarkEditor;
